import { render, staticRenderFns } from "./UserRolePage.vue?vue&type=template&id=346e1bfc&scoped=true"
import script from "./UserRolePage.vue?vue&type=script&lang=js"
export * from "./UserRolePage.vue?vue&type=script&lang=js"
import style0 from "./UserRolePage.vue?vue&type=style&index=0&id=346e1bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346e1bfc",
  null
  
)

export default component.exports